import React from 'react';
import { IDNameDescriptionItem, LeadModel, SPLeadModel, RiderLeadModel } from '../models/superbit-api-models'
import { GeneralDataModel } from '../models/GeneralDataModel'
import { PolicyModel } from '../models/PolicyModel'
import { StatOptions } from 'fs';
import { Select, Tooltip } from 'antd';
import OpenRenewal from './_OpenRenewal'
import moment from 'moment';
import { LinkToSimulator } from '../leads/_LinkToSimulator';
import generalSettings from '../json/general-settings.json';
import { IDNameDescriptionDictionary } from '../models/Site';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoenixFramework } from '@fortawesome/free-brands-svg-icons';
import { faHammer, faPhone } from '@fortawesome/free-solid-svg-icons';
import CallButton from '../components/_CallButton';
import ClientPolicyDetails from '../clients/PolicyDetails/_ClientPolicyDetails';

import "./Renewal.css";



type Props = {
    lead: SPLeadModel | null;
    rider: RiderLeadModel | undefined;
    checked?: boolean
    isSalespersonAssignment?: boolean;
    getAuthorizedToDriveName: any;
    onEdit: Function;
    onDelete: Function;
    navigation?: any;
    opened?: boolean;
    openPopupMessage?: Function;
    openDocumentPopup: Function;
    isAdmin?: boolean;
    updateLeadStatus: Function;
    leadStatuses: any[],
    onGoToSimulatorClick: Function;
    onCallStart: Function;
    onCheckRenewal: Function;
    checkPermissionsOfCreator: () => boolean;
    checkPermissionsOfEdit: () => boolean;
    setRiderForRenewPopup:Function;
};

type State = {
    open: boolean,
    checked?: boolean,
    lead: LeadModel | undefined;
    showBtnOptions: boolean;
    leadId: string,
    address: any;
    leadTopTypeLabel: string,
    leadTypeLabel: string,
    propertyType: string;
    InsuranceTypes: IDNameDescriptionDictionary;
    PolicyTypes: IDNameDescriptionDictionary;
    insuranseType: any;
    policyType: any;
    showStatusSelect: boolean;
    simulatorPermission: boolean;
    ExpandedInsuranceTypes: any;
    ExpandedInsuranceType: string;

};

export class RiderRenewal extends React.Component<Props, State> {
    leadId = '';
    leadRef: any;
    leadStatusCell: React.RefObject<any>;
    leadStatusSelect: React.RefObject<any>;

    constructor(props: any) {
        super(props);
        this.openLead = this.openLead.bind(this);
        let leadId = '0';



        if (this.props.lead && this.props.lead != null && this.props.lead.lead != null && this.props.lead.lead.id != null) {
            const lead = this.props.lead.lead;
            leadId = this.props.lead.lead.id;
        }
        this.state = {
            open: false,
            showBtnOptions: false,
            lead: this.props.lead ? this.props.lead.lead : new LeadModel(),
            leadId: leadId.toString(),
            address: null,
            leadTopTypeLabel: '',
            leadTypeLabel: '',
            propertyType: '',
            InsuranceTypes: generalSettings.InsuranceTypes,
            PolicyTypes: generalSettings.policyTypes,
            insuranseType: {},
            policyType: {},
            showStatusSelect: false,
            simulatorPermission: false,
            checked: this.props.checked,
            ExpandedInsuranceTypes: [],
            ExpandedInsuranceType: "",

        }
        this.leadRef = React.createRef();
        this.leadStatusCell = React.createRef();
        this.leadStatusSelect = React.createRef();
        // this.dispatch = useDispatch();
    }




    async getExpandedInsuranceType() {

        let jsonString = localStorage.getItem('ExpandedInsuranceTypes');
        let ExpandedInsuranceTypes: any[] = Object.values(jsonString ? JSON.parse(jsonString) : []);

        var arr = Array.isArray(ExpandedInsuranceTypes);

        if (!ExpandedInsuranceTypes || ExpandedInsuranceTypes.length === 0) {
            ExpandedInsuranceTypes = await new GeneralDataModel().getExpandedInsuranceTypes();
            localStorage.setItem('ExpandedInsuranceTypes', JSON.stringify(ExpandedInsuranceTypes));
        }

        if (ExpandedInsuranceTypes && this.props.lead && this.props.lead.lead && this.props.lead.lead.policy && this.props.lead.lead.policy.policyAdditionDetails) {
            var type = this.props.lead.lead.policy.policyAdditionDetails.vehiclePolicyType;

            let item = ExpandedInsuranceTypes.find((x: any) => x.id === type);
            let desc = item ? item.description : "";
            this.setState({ ExpandedInsuranceType: desc });
        }
    }

    componentDidMount() {
        moment.locale('he');
        this.onLoad();
        if (this.state.lead) {
            // console.log('lead loaded', this.state.lead.id)
            // console.log('opened', this.state.lead.id, this.props.opened)
        }
    }

    scrollToElement = () => {
        if (this.leadRef && this.leadRef.current) {
            this.leadRef.current.scrollIntoView();
        }
    };

    onLoad = async () => {

        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Simulator');

            if (moodelPermision && moodelPermision.permissionType == 2) {
                this.setState({ simulatorPermission: true });
            } else {
                this.setState({ simulatorPermission: false });
            }
        }


        if (this.props.opened) {
            // this.setState({ open: true });
            this.openLead(true);
        }
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            this.leadId = this.props.lead.lead.id;
            this.props.lead.lead.deliveryDate = moment(this.props.lead.lead.deliveryDate).format('DD-MM-YYYY') == "01-01-0001" ? undefined : this.props.lead.lead.deliveryDate;
            this.setState({
                leadId: this.leadId
            })
        }
        let address = null;
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.involvedAddress) {
            // console.log(this.props.lead.lead.involvedAddress);
            address = this.props.lead.lead.involvedAddress;
            this.setState({
                address: address
            })
        }

        const leadTypes: string[] = [
            'חדש',
            'סלקט',
            'משומש'
        ];
        const leadTopTypes: string[] = [
            'רכב',
            'דירה/עסק',
            'אחר'
        ];

        let leadTopTypeLabel = leadTopTypes[0];
        let leadType = 0;
        let leadTypeLabel = '';
        if (this.props.lead && this.props.lead.lead) {
            if (this.props.lead.lead.leadTopType && this.props.lead.lead.leadTopType > 0) {
                leadTopTypeLabel = '';
                leadTypeLabel = '';
            } else {
                if (this.props.lead.lead.leadType) {
                    leadType = this.props.lead.lead.leadType;
                }
                leadTypeLabel = leadTypes[leadType];
            }
        }

        const propertyTypes = [
            "דירה",
            "משרד",
            "בית פרטי",
            "עסק"
        ];
        let propertyType = propertyTypes[0];
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.propertyType) {
            propertyType = propertyTypes[this.props.lead.lead.propertyType];
        }
        let insuranseType = {};
        if (this.props.lead && this.props.lead.lead) {
            insuranseType = this.state.InsuranceTypes[(this.props.lead.lead as any).insuranceType];
        }
        let policyType = {};
        if (this.props.lead && this.props.lead.lead) {
            policyType = this.state.PolicyTypes[(this.props.lead.lead as any).policyType];
        }

        // console.log(insuranseType);
        this.setState({
            leadTopTypeLabel: leadTopTypeLabel,
            leadTypeLabel: leadTypeLabel,
            propertyType: propertyType,
            insuranseType: insuranseType,
            policyType: policyType,

        });
        this.getExpandedInsuranceType();
    }

    async openLead(closed?: boolean) {
        var open = closed ? true : !this.state.open;
        this.setState({ open: open });
        if (open) {


            this.scrollToElement();
        }
    }

    onEdit = () => {
        // console.log('Lead Edit', this.leadId )
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            console.log('Lead Edit', this.props.lead.lead.id)
            this.props.onEdit(this.props.lead.lead.id);
        }
    }

    onDelete = () => {
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            console.log('Lead Delete', this.props.lead.lead.id)
            this.props.onDelete(this.props.lead.lead.id);
        }
    }

    onSimulatorClick = () => {
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            // console.log('Lead to Simulator', this.props.lead.lead.id)
            if (this.props.onGoToSimulatorClick) {
                this.props.onGoToSimulatorClick(this.props.lead.lead.id);
            }
        }
        // localStorage.setItem('leadid', this.state.leadId);
        // console.log('Lead to Simulator', this.state.leadId)
    }

    toggleBtnMenu() {
        const curentState = this.state.showBtnOptions;
        this.setState({
            showBtnOptions: !curentState
        })
    }
    onActionBtnClick(e: any) {
        e.preventDefault();
        console.log('onActionBtnClick', e, e.target.className);
        this.toggleBtnMenu()
    }
    onCheckClick(e: React.ChangeEvent<HTMLInputElement>) {

        const isShiftPressed = e.nativeEvent instanceof PointerEvent
            ? (e.nativeEvent as PointerEvent).shiftKey
            : false;
        this.props.onCheckRenewal(this.leadId, isShiftPressed);
    }

    onRowClick(e: any) {
        if (e.target.parentElement.className.indexOf('cell') >= 0) {
            if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
                e.target.className == 'action-btn-menu-item pointer' ||
                e.target.className == 'ant-select-selection-item' ||
                e.target.className == 'ant-select-item-option-content' ||
                e.target.className == 'icon paperclip pointer' ||
                e.target.className == 'description bold cell-value phone-number' ||
                e.target.parentElement.className == 'cell car-details' ||
                e.target.parentElement.className.indexOf('on-click-ignore') > 0
            ) return;
            try {
                if (this.leadStatusCell.current && this.leadStatusCell.current.contains(e.target)) {
                    return;
                }
                if (this.leadStatusSelect && this.leadStatusSelect.current && this.leadStatusSelect.current.contains(e.target)) {
                    return;
                }
            } catch (error) {
                // return;
            }
            this.setState({
                showStatusSelect: false
            })
            this.openLead(!this.state.open);
        }
        if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
            e.target.className == 'action-btn-menu-item pointer' ||
            e.target.className == 'ant-select-selection-item' ||
            e.target.className == 'ant-select-item-option-content' ||
            e.target.className == 'icon paperclip pointer' ||
            e.target.className == 'description bold cell-value phone-number' ||
            e.target.parentElement.className == 'cell car-details' ||
            e.target.parentElement.className.indexOf('on-click-ignore') > 0
        ) return;
    }

    onMenuClick(action: string, value?: string) {
        // console.log(action);
        switch (action) {
            case 'edit':
                this.onEdit();
                break;
            case 'delete':
                this.onDelete();
                break;
            case 'simulator': {
                // console.log('LeadId', this.state.leadId, this.props);
                localStorage.setItem('leadid', this.state.leadId)
                break;
            }
            default:
                break;
        }
        this.toggleBtnMenu()
    }

    openPopupMessage(d: any) {
        if (this.props.openPopupMessage) {
            this.props.openPopupMessage(d);
        }
    }

    openDocumentPopup() {
        if (this.props.lead && this.props.lead.lead) {
            const lead = this.props.lead.lead;
            if (lead.carLicenseFilePath) {
                this.props.openDocumentPopup(lead.carLicenseFilePath)
            } else {
                if (lead.vehicle) {
                    const vehicle = lead.vehicle;
                    if (vehicle != null && typeof vehicle.carLicenseFilePath != 'undefined' && vehicle.carLicenseFilePath) {
                        this.props.openDocumentPopup(vehicle.carLicenseFilePath)
                    }
                }
            }
        }
    }

    Call(e: any) {
        e.stopPropagation();
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.phoneNumber1 && this.props.lead.lead.id) {
            new GeneralDataModel().speakComSendCall(this.props.lead.lead.phoneNumber1, this.props.lead.lead.id);
            // this.dispatch(startCall());
        }
    }

    toggleShowStatuses() {
        this.setState({
            showStatusSelect: !this.state.showStatusSelect
        })
    }

    updateLeadStatus(statusId: string) {
        if (this.props.updateLeadStatus && this.props.lead && this.props.lead.lead) {
            this.props.updateLeadStatus(this.props.lead.lead.id, statusId);
            this.setState({
                showStatusSelect: false
            })
        }
    }
    openRenew(){
        if(this.props.rider && this.props.rider.oldRider){
            this.props.setRiderForRenewPopup(this.props.rider.oldRider);
        }
        
    }

    render() {
        let vehicle = null;

        if (this.props.lead && this.props.lead != null && this.props.lead.lead != null)
            vehicle = this.props.lead.lead.vehicle;
        return (
            <div ref={this.leadRef}>
                {this.props.rider != null && this.props.rider.oldRider != null ? (
                    <>
                        
                            <div className={this.state.open ? "hide" : "body-line"} id={`lead-row-${this.props.rider.oldRider.id}`} onClick={(e: any) => this.onRowClick(e)}>
                                <div className={this.props.isSalespersonAssignment ? "hide" : "chechbox-cell"}>
                                    <div><input checked={this.props.checked} onClick={(e: any) => this.onCheckClick(e)} type='checkbox'></input></div>
                                </div>
                                <div className="empty-cell">
                                    
                                </div>
                                <div className="status-cell" ref={this.leadStatusCell} style={{ minWidth: '110px' }}>
                                    {/* <div className="title">סטטוס</div> */}
                                    <div className="flex-end" style={{ width: '100px' }}>
                                        <div className={`status flex-centered flex-space-between ${!this.state.showStatusSelect ? '' : 'hide'}`} onClick={() => this.toggleShowStatuses()}>
                                            <div className="status-circle"></div>
                                            <div className="sub-title">{this.props.rider ?( this.props.rider.statusId == 0 ? "חדש" : "הופק"):""}</div>
                                            <div className="qty">
                                                
                                            </div>
                                        </div>
                                        <div className={`${this.state.showStatusSelect ? '' : 'hide'}`}>
                                            <Select ref={this.leadStatusSelect}
                                                allowClear
                                                style={{ width: '90px' }}
                                                defaultValue={this.props.rider.oldRider.riderStatusType+""}
                                                onChange={(v: string) => this.updateLeadStatus(v)}
                                                options={this.props.leadStatuses.map(
                                                    (item: any) => ({ label: item.text, value: item.value }))}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="fullName-cell">
                                    
                                        {this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.customer ? this.props.rider.oldRider.customer.fullName : ""}
                                    
                                </div>
                                <div className="handler-cell">
                                    
                                        {this.props.rider && this.props.rider.oldRider ? this.props.rider.oldRider.handlerName : ""}
                                    
                                </div>
                                <div className="identifier-cell">
                                    
                                        {this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.customer ? this.props.rider.oldRider.customer.identifier : ""}
                                    
                                </div>
                                <div className="phoneNumber-cell on-click-ignore">
                                        <div className="">{this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.customer && this.props.rider.oldRider.customer.customerContactDetails && this.props.rider.oldRider.customer.customerContactDetails.length > 0 ? this.props.rider.oldRider.customer.customerContactDetails[0].number : ""}</div>
                                        <CallButton onStart={(e: any) => this.Call(e)} user={{
                                            userName: this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.customer ? this.props.rider.oldRider.customer.fullName : "",
                                            userPhone: this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.customer && this.props.rider.oldRider.customer.customerContactDetails && this.props.rider.oldRider.customer.customerContactDetails.length > 0 ? this.props.rider.oldRider.customer.customerContactDetails[0].number : ""
                                        }} />
                                        {/* <div className='pointer' onClick={(e:any)=>this.Call(e)}><FontAwesomeIcon icon={faPhone} /></div> */}

                                </div>
                                <div className="carDetails-cell on-click-ignore">
                                    <div className="sub-title">{this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.vehicle != null && this.props.rider.oldRider.vehicle.vehicleSubModel != null ? this.props.rider.oldRider.vehicle.vehicleSubModel.modelCode : ""}</div>
                                    <div className="description">{this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.vehicle != null && this.props.rider.oldRider.vehicle.vehicleSubModel != null ? this.props.rider.oldRider.vehicle.vehicleSubModel.name : ""}</div>
                                    <div className="description">{this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.vehicle != null && this.props.rider.oldRider.vehicle.vehicleSubModel != null ? this.props.rider.oldRider.vehicle.licenseNumber : ""}</div>

                                </div>
                                <div className="policyNumber-cell">
                                        {this.props.rider && this.props.rider.oldRider ? this.props.rider.oldRider.subscriberNumber : ""}
                                </div>
                                <div className="policyType-cell">
                                        ריידר
                                </div>
                                <div className="policyType-cell">
                                   
                                </div>
                                <div className="company-cell">
                                        {this.props.rider ? this.props.rider.companies: ""}
                                </div>
                                <div className="branch-cell">
                                        {this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.riderPackages && this.props.rider.oldRider.riderPackages.length > 0 ?
                                            this.props.rider.oldRider.riderPackages
                                                .map(pkg => pkg.riderPackage ? pkg.riderPackage.name : "")
                                                .join(', ')
                                            : ""}
                                </div>
                                <div className="endDate-cell">
                                        {this.props.rider && this.props.rider.oldRider && this.props.rider.oldRider.endDate ? moment(this.props.rider.oldRider.endDate).format('DD-MM-YYYY') : ""}
                                </div>


                                <div className='option-cell desktop-only' >
                                    {/* <button
                                className="act-btn"
                                onClick={(e: any)=>{this.onActionBtnClick(e)}}>
                            </button> */}
                                    <div className='act-btn-icon icon menu-hamburger pointer'
                                        onClick={(e: any) => { this.onActionBtnClick(e) }}></div>
                                    {this.state.showBtnOptions && (
                                        <ul className="btn-menu">
                                            {this.props.checkPermissionsOfEdit() ? (
                                                <li className="action-btn-menu-item pointer"
                                                    onClick={() => { this.onMenuClick('edit') }}
                                                >
                                                    ערוך
                                                </li>
                                            ) : (<></>)}
                                            {
                                                this.props.isAdmin ? (<>
                                                    <li className="action-btn-menu-item pointer"
                                                        onClick={() => { this.onMenuClick('delete') }}
                                                    >
                                                        מחק
                                                    </li>
                                                </>) : (<></>)
                                            }
                                            <li className="action-btn-menu-item pointer">
                                                הדפס
                                            </li>
                                            <li className="pointer"
                                                onClick={() => { this.openRenew() }}
                                            >
                                                חידוש מנוי                                            
                                            </li>
                                            
                                        </ul>
                                    )}
                                </div>
                                <div className="action-cell" >
                                    <div className="icon left-arrow" onClick={(e: any) => this.openLead()}></div>
                                </div>
                                
                            </div>

    

                        {this.state.open ? (
                            <>

                                <OpenRenewal
                                    getAuthorizedToDriveName={this.props.getAuthorizedToDriveName}
                                    lead={this.props.lead}
                                    open={this.state.open}
                                    closeLead={this.openLead}
                                    onMenuClick={(e: any) => this.onMenuClick(e)}
                                    openPopupMessage={(d: any) => this.openPopupMessage(d)}
                                    simulatorPermission={this.state.simulatorPermission}
                                    isAdmin={this.props.isAdmin}
                                ></OpenRenewal>
                            </>

                        ) : ''}
                    </>
                ) : (
                    <p>No lead</p>
                )}
            </div>



        );
    }
}
